<template>
<div id="addEdit">
  <el-dialog title="编辑对单" :visible.sync="visible" width="700px" @closed="formData.video={}">
    <el-form :model="formData" :rules="rules" ref="form" label-width="100px" size="small">
      <el-form-item label="征信情况" prop="credit_id">
        <el-select v-model="formData.credit_id" placeholder="请选择征信情况" style="width: 100%;">
          <el-option v-for="item in creditList" :key="item.credit_id" :label="item.name" :value="item.credit_id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="年龄" prop="age">
        <el-input v-model="formData.age" placeholder="请输入年龄"></el-input>
      </el-form-item>

            <!-- 城市 -->
      <el-form-item label="城市" prop="city_id">
        <el-select v-model="formData.city_id" placeholder="请选择城市" style="width: 100%;">
          <el-option v-for="item in cityList" :key="item.city_id" :label="item.name" :value="item.city_id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="所需额度" prop="money">
        <el-input v-model="formData.money" placeholder="请输入所需额度">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="业务类型" prop="business_ids">
        <el-checkbox-group v-model="formData.business_ids" style="width: 100%;">
          <el-checkbox v-for="item in businessList" :key="item.business_id" :label="item.business_id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="您的信息" prop="content">
        <el-input type="textarea" v-model="formData.content" placeholder="请详细描述您的鉴定需求"></el-input>
      </el-form-item>

      <el-form-item label="文件信息" prop="images">
        <div class="draggable-list">
          <div class="item" v-for="(item, index) in formData.images" :key="item.file_path">
            <img v-img-url="item.file_path" />
            <a href="javascript:void(0);" class="delete-btn" @click.stop="formData.images.splice(index,1)"><i class="el-icon-close"></i></a>
          </div>
          <div v-if="formData.images.length<8" class="item img-select" @click="isupload=true;uploadKey='images'"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="submitSave" :loading="loading">确定</el-button>
    </div>

  </el-dialog>


  <Upload v-if="isupload" :config="config" :isupload="isupload" @returnImgs="uploadChange">上传图片</Upload>


</div>
</template>

<script>
import NeedApi from '@/api/need'
import Getpoint from '@/components/map/Getpoint.vue';
import Upload from '@/components/file/Upload';
export default {
  components:{Upload,Getpoint},
  data(){
    return{
      loading:false,
      isupload:false,
      visible:false,
      uploadKey:'',
      uploadType:'images',
      formData:{
        need_id:'',
        credit_id:'',
        age:'',
        money:'',
        city_id:'',
        business_ids:[],
        content:'',
        images:[],
      },
      rules:{
        credit_id: [{ required: true, message: '请选择征信情况', trigger: 'blur' }],
        age: [{ required: true, message: '请输入年龄', trigger: 'blur' }],
        money: [{ required: true, message: '请输入所需额度', trigger: 'blur' }],
        city_id: [{ required: true, message: '请选择城市', trigger: 'blur' }],
        business_ids: [{ required: true, message: '请选择业务类型', trigger: 'blur' }],
        content: [{ required: true, message: '请详细描述您的鉴定需求', trigger: 'blur' }],
        // images: [{ required: true, message: '请上传图片', trigger: 'blur' }],
      },
      config:{
        total: 8,
        file_type: 'image'
      },
    }
  },
  props:{
    cityList:Array,
    creditList:Array,
    businessList:Array,
  },
  methods:{

    // 保存
    submitSave(){
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          let params=JSON.parse(JSON.stringify(this.formData))
          params.business_ids=params.business_ids.join(',')
          NeedApi.needEdit(params).then(result => {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.$emit('refresh')
            this.visible = false
          }).finally(()=>{
            this.loading = false
          })
        }
      })
    },

    show(e){
      if(e){
        e=JSON.parse(JSON.stringify(e))
        for(let i in this.formData){
          this.formData[i]=e[i]
        }
        this.formData.business_ids=e.business_ids.split(',').map(item=>Number(item))
      }
      this.visible=true
    },

    // 图片选择
    uploadChange(e){
      console.log(e);
      let key=this.uploadKey
      if(e&&e!=''){
        let max=8-this.formData[key].length
        let eLen=e.length
        if(eLen>max){
          e=e.slice(0,max)
        }
        for(let i in e){
          this.formData[key].push(e[i]);
        }
      }
      this.isupload=false
    },

  }
}
</script>

<style lang="scss" scoped>
.img{margin-top: 10px;}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/need/need/addEdit.vue